interface LatLng {
  lat: number
  lng: number
}

export interface GeoBounds {
  northEast: LatLng
  southWest: LatLng
}

/**
 * Computes geographical bounds from a list of points.
 */
export function computeBoundsFromLatLngs(points: LatLng[]): GeoBounds {
  let minLat = Infinity
  let maxLat = -Infinity
  let minLng = Infinity
  let maxLng = -Infinity

  points.forEach((point) => {
    const { lat, lng } = point
    minLat = Math.min(minLat, lat)
    maxLat = Math.max(maxLat, lat)
    minLng = Math.min(minLng, lng)
    maxLng = Math.max(maxLng, lng)
  })

  return {
    northEast: { lat: maxLat, lng: maxLng },
    southWest: { lat: minLat, lng: minLng },
  }
}
